import { useSyncExternalStore } from "react";

const PHONE_QUERY = "(max-width: 767px)";

export function isPhone() {
    return typeof window.matchMedia === "function" && window.matchMedia(PHONE_QUERY).matches;
}

function getServerSnapshot() {
    return false;
}

function subscribe(onStoreChange: () => void) {
    if (typeof window.matchMedia !== "function") {
        return () => {};
    }

    const mediaQueryList = window.matchMedia(PHONE_QUERY);

    mediaQueryList.addEventListener("change", onStoreChange);

    return () => mediaQueryList.removeEventListener("change", onStoreChange);
}

export function useIsPhone() {
    return useSyncExternalStore(subscribe, isPhone, getServerSnapshot);
}
